import { doc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const DeleteClass = async (ID) => {
  try {
    const ClassDocument = doc(db, "Classes", ID);

    await updateDoc(ClassDocument, {
      IsDeleted: true,
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default DeleteClass;
